<template>
  <div class="tile-preview-container">
    <div class="tile-promo-display-selections-div">
      <div
        v-if="
          appsStore.app?.flags?.new_android_editor
            ? !['interstitial', 'retention_modal'].includes(model.path_type)
            : true
        "
        class="tile-promo-display-selections-opt"
      >
        <button
          class="tab"
          :class="{ active: viewTypeTab === 'desktopViewTab' }"
          @click="$emit('clickTab', 'desktopViewTab')"
        >
          {{ appsStore.app?.flags?.new_android_editor ? "TV" : "TV & Tablet" }}
        </button>
        <button
          class="tab"
          :class="{ active: viewTypeTab === 'mobilewebViewTab' }"
          @click="$emit('clickTab', 'mobilewebViewTab')"
        >
          {{ appsStore.app?.flags?.new_android_editor ? "Mobile & Tablet" : "Phone" }}
        </button>
      </div>
      <div class="tab-selector mr-4">
        <RfLiquidPreview
          v-model:userData="liquidContextStore.previewUserContext"
          :appId="appsStore.app?.id"
        />
        <RfLanguagePreview :model="model" :actions="actions" />
      </div>
    </div>
    <v-tabs-window :modelValue="viewTypeTab" class="h-full w-full cursor-not-allowed">
      <v-window-item
        id="desktopViewTab"
        :transition="false"
        class="h-full w-full overflow-auto"
        :class="{ 'min-h-full!': appsStore.app?.flags?.new_android_editor }"
        :reverseTransition="false"
        value="desktopViewTab"
      >
        <RfRetentionModal
          ref="android_os_tv"
          :model="model"
          :class="{ 'h-full! min-h-full!': appsStore.app?.flags?.new_android_editor }"
          :actions="previewActions"
          :zoomStyle="zoomStyle"
          :isMobile="model.path_type === 'interstitial'"
          :isNewDeviceEditor="appsStore.app?.flags?.new_android_editor"
          :deviceType="appsStore.app?.flags?.new_android_editor ? 'androidTV' : 'androidLandscape'"
        />
      </v-window-item>
      <v-window-item
        id="mobilewebViewTab"
        :transition="false"
        :reverseTransition="false"
        value="mobilewebViewTab"
        class="h-full w-full overflow-auto"
      >
        <RfRetentionModal
          ref="android_os_phone"
          :model="model"
          isMobile
          :actions="previewActions"
          :isNewDeviceEditor="appsStore.app?.flags?.new_android_editor"
          :deviceType="appsStore.app?.flags?.new_android_editor ? 'androidSquare' : 'mobileWeb'"
        />
      </v-window-item>
    </v-tabs-window>
    <div v-if="viewTypeTab === 'desktopViewTab'" class="preview-control-buttons">
      <v-btn size="small" color="#f3f3f3" @click="zoomIn">+</v-btn>
      <v-btn class="reset-zoom-btn" size="small" color="#f3f3f3" @click="resetZoom">{{
        `${zoomValue * 100}%`
      }}</v-btn>
      <v-btn size="small" color="#f3f3f3" @click="zoomOut">-</v-btn>
    </div>
    <component :is="'style'" v-if="actions.rf_settings_custom_css">
      {{ actions.rf_settings_custom_css }}
    </component>
  </div>
</template>
<script>
import RfRetentionModal from "@/components/RfPathCreate/RfRetentionActions/RfRetentionModal.vue";
import ZoomPreviewMixin from "@/utils/ZoomPreviewMixin";
import LanguagePreviewMixin from "@/utils/LanguagePreviewMixin";
import RfLanguagePreview from "@/components/RfPathCreate/RfRetentionDevices/RfLanguagePreview.vue";
import CompositeImageSaver from "@/utils/CompositeImageSaver";
import { useAppsStore } from "@/pinia/appsStore";
import RfLiquidPreview from "./RfLiquidPreview.vue";
import { useLiquidContextStore } from "@/pinia/liquidContextStore";

export default {
  name: "RfRetentionDeviceAndroidOs",
  components: { RfRetentionModal, RfLanguagePreview, RfLiquidPreview },
  mixins: [ZoomPreviewMixin, LanguagePreviewMixin],
  props: ["actions", "viewTypeTab", "model"],
  setup: () => ({
    appsStore: useAppsStore(),
    liquidContextStore: useLiquidContextStore(),
  }),
  methods: {
    async fillModel(model) {
      if (!model.device_type) {
        model.device_type = this.model.device_type;
      }
      await CompositeImageSaver.fill(model, this.$refs, this.appsStore.app);
    },
  },
};
</script>
